<% if (providers.length) { %>
  <header class="related-providers-widget__header"><%= I18n.title %></header>

  <div class="related-providers-widget__content">
    <% _.each(providers, function(provider) { %>
      <%= window.Sparkle.Client.jstTemplate('appointment_booking/related_providers_widget/templates/_provider')({provider: provider, I18n: I18n}) %>
    <% }) %>
  </div>

  <% if (backToSearchUrl) { %>
    <div class="related-providers-widget__footer">
      <sp-icon name="arrow-closed-left-filled" size="x-small"></sp-icon>
      <a href=<%= backToSearchUrl %> class="related-providers-widget-link"><%= I18n.back_to_search %></a>
    </div>
  <% } %>
<% } %>
